export const OTP_FIELD_MACHINE_ID = 'otpFieldMachine';

export const RESEND_ENABLE = 'RESEND_ENABLE';
export const RESEND_ENABLE_STATE = 'resendEnable';

export const RESEND_DISABLE = 'RESEND_DISABLE';
export const RESEND_DISABLE_STATE = 'resendDisable';

export const OTP_FIELD_INITIAL_STATE = 'otpFieldInitialState';

export const VERIFY_OTP_BUTTON_CLICKED = 'VERIFY_OTP_BUTTON_CLICKED';
export const VERIFY_OTP_BUTTON_CLICKED_STATE = 'verifyOTPButtonClicked';

export const RESEND_OTP_CLICKED = 'RESEND_OTP_CLICKED';
export const RESEND_OTP_CLICKED_STATE = 'resendOTPClicked';

export const RESEND_OTP_THROUGH_CALL_CLICKED =
  'RESEND_OTP_THROUGH_CALL_CLICKED';
export const RESEND_OTP_THROUGH_CALL_CLICKED_STATE =
  'resendOTPThroughCallClicked';

export const OTP_LOADING = 'OTP_LOADING';

export const VERIFY_OTP_FAILED = 'VERIFY_OTP_FAILED';
export const VERIFY_OTP_FAILED_STATE = 'verifyOTPFailed';

export const OTP_VERIFIED_STATE = 'OTP_VERIFIED_STATE';

export const ON_SUCCESS_OTP_VERIFICATION = 'ON_SUCCESS_OTP_VERIFICATION';

export const RESENDING_OTP_TAG = 'resendingOTPTag';

export const RESEND_OTP_FAILED_STATE = 'resendOTPFailed';

export const CLEAR_OTP_ERROR = 'CLEAR_OTP_ERROR';

export const OTP_STATE_MACHINE_ID = 'otpStateMachine';

export const states = {
  RESEND_DISABLE_STATE: 'resendDisableState',
  RESEND_ENABLED_STATE: 'resendEnableState'
};

export const events = {
  RESEND_DISABLE: 'RESEND_DISABLE',
  RESEND_ENABLE: 'RESEND_ENABLE'
};
